import React from 'react';
import './style.css'

const NotFound = () => (
  <div className="NotFound-info">
    <h1 className="NotFound-info__description">404 - Not Found!</h1>
  </div>
);

export default NotFound;